import { html } from '@microsoft/fast-element';
import { staticallyCompose } from '@microsoft/fast-foundation';
import type { Footer } from './footer.js';

import copyrightBlack from '/brand/logo-mark-black.svg?raw';
import copyrightWhite from '/brand/logo-mark-white.svg?raw';

export default html<Footer>`
	<template role="contentinfo">
		<div part="positioning-region">
			<p part="copyright">
				<span class="logo-mark">
					${staticallyCompose(copyrightBlack)}
				</span>
				<span class="logo-mark-white">
					${staticallyCompose(copyrightWhite)}
				</span>
				<span>Copyright &#169; ${x => x.currentYear} Translational Analytics & Statistics, LLC. All rights reserved.</span>
			</p>
			<adaptive-button
				id="to-top"
				@click=${x => x.scrollToTop()}
			>
				<visually-hidden>Scroll to top</visually-hidden>
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="m7.293 8.293l3.995-4a1 1 0 0 1 1.32-.084l.094.083l4.006 4a1 1 0 0 1-1.32 1.499l-.094-.083l-2.293-2.291v11.584a1 1 0 0 1-.883.993L12 20a1 1 0 0 1-.993-.884L11 19.001V7.41L8.707 9.707a1 1 0 0 1-1.32.084l-.094-.084a1 1 0 0 1-.084-1.32l.084-.094l3.995-4l-3.995 4Z"/></svg>
			</adaptive-button>
		</div>
	</template>
`;